import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-popup-consent-pin',
  templateUrl: './popup-consent-pin.component.html',
  styleUrls: ['./popup-consent-pin.component.scss']
})

export class PopupConsentPinComponent implements OnInit {

  @Input() data: any;

  showError = false;
  pin: Array<any> = [];

  constructor() { }

  ngOnInit() {
    this.showPopup();
  }

  moveNext(event) {
    let inputRegex = /\d/;
    if (inputRegex.test(event.key)) {
      if (event.target.value.length == 1) {
        event.target.nextSibling.focus();
      }
      this.showError = false;
    } else if (event.key == "Backspace") {
      event.target.value = "";
      event.target.previousSibling.focus();
      this.showError = false;
    }else{
      event.preventDefault();
      return false;
    }
  }

  showPopup() {
    let item: any = document.getElementsByClassName("consent-confirm-focus")[0];
    setTimeout(() => {
      item.focus();
    }, 0);
  }

  closePopup() {
    this.data.popupComponentClose();

    if(this.data.cancelCallback) {
      this.data.cancelCallback();
    }
  }

  confirm() {
    let consetpin = this.pin.join("");

    if(consetpin.length != 6) {
      this.showError = true;
      return;
    }

    this.data.successCallback(consetpin);
  }

}

